// @ts-strict-ignore
import { SQL_JS_CONFIG } from 'common_lib/db/sqlite'
import L from 'leaflet'
import initSqlJs from 'sql.js'

/*
***
ADAPTED from https://github.com/0nza1101/leaflet-tilelayer-mbtiles-ts/blob/master/index.ts as we need to adjust a few things
***
*/
import { getStringDatabase, getValueFromTable, processBounds } from './functions'

let storedTiles = []
;(L.TileLayer as any).MBTiles = L.TileLayer.extend({
	initialize: function (databaseUrl: string | ArrayBuffer, options?: any) {
		this._databaseIsLoaded = false
		if (typeof databaseUrl === 'string') {
			getStringDatabase(databaseUrl)
				.then(buffer => this._openDB(buffer))
				.catch(err => this.fire('databaseerror', { error: err }))
		} else if (databaseUrl instanceof ArrayBuffer) {
			this._openDB(databaseUrl)
		} else {
			this.fire('databaseerror')
		}

		this.on('tileunload', (event: any) => {
			if (event.tile && event.tile.src != L.Util.emptyImageUrl) {
				URL.revokeObjectURL(event.tile.src)
			}
		})

		const closeDb = (): void => this._db.close()
		this.on('remove', () => {
			if (this._databaseIsLoaded) {
				closeDb()
			} else {
				this.on('databaseloaded', closeDb)
			}
		})

		return (L.TileLayer.prototype as any).initialize.call(this, '', options)
	},

	_openDB: function (buffer: ArrayBuffer) {
		try {
			initSqlJs(SQL_JS_CONFIG)
				.then(SQL => {
					const uInt8Array = new Uint8Array(buffer)
					this._db = new SQL.Database(uInt8Array)

					// TODO: keep until the georeferenced map is ready
					// this._stmt = this._db.prepare(
					// 	'SELECT tile_data FROM tiles WHERE zoom_level = :z AND tile_column = :x AND tile_row = :y',
					// )
					const storedData = this._db.exec('SELECT tile_data, zoom_level, tile_column, tile_row FROM tiles')
					const tilesValues = storedData?.[0]?.values

					storedTiles = tilesValues?.reduce(
						(acc, value) => ({
							...acc,
							// the key created from columns in the next format: {zoom_level}_{tile_column}_{tile_row}
							[`${value[1]}_${value[2]}_${value[3]}`]: value[0],
						}),
						{},
					)

					const metaStmt = this._db.prepare('SELECT value FROM metadata WHERE name = :key')

					const attribution = getValueFromTable(metaStmt, 'attribution')
					if (attribution) {
						this.options.attribution = attribution
					}

					const minZoom = getValueFromTable(metaStmt, 'minzoom', Number)
					if (minZoom) {
						this.options.minZoom = minZoom
					}

					const maxZoom = getValueFromTable(metaStmt, 'maxzoom', Number)
					if (maxZoom) {
						this.options.maxZoom = maxZoom
					}

					const bounds = getValueFromTable(metaStmt, 'bounds', processBounds)

					const format = getValueFromTable(metaStmt, 'format')
					if (format === 'png') {
						this._format = 'image/png'
					} else if (format === 'jpg') {
						this._format = 'image/jpg'
					} else {
						this._format = 'image/png'
					}

					this.fire('databaseloaded', {
						minZoom,
						maxZoom,
						bounds,
					})
					this._databaseIsLoaded = true
				})
				.catch(err => {
					console.error('initSqlJs error', err)
				})
		} catch (ex) {
			this.fire('databaseerror', { error: ex })
		}
	},

	createTile: function (coords: any, done: any) {
		const tile = document.createElement('img')

		if (this.options.crossOrigin) {
			tile.crossOrigin = ''
		}
		tile.alt = ''
		tile.setAttribute('role', 'presentation')

		if (this._databaseIsLoaded) {
			L.DomEvent.on(tile, 'load', L.Util.bind(this._tileOnLoad, this, done, tile))
			L.DomEvent.on(tile, 'error', L.Util.bind(this._tileOnError, this, done, tile))

			tile.src = this.getTileUrl(coords)
		} else {
			this.on(
				'databaseloaded',
				function (): void {
					L.DomEvent.on(tile, 'load', L.Util.bind(this._tileOnLoad, this, done, tile))
					L.DomEvent.on(tile, 'error', L.Util.bind(this._tileOnError, this, done, tile))

					tile.src = this.getTileUrl(coords)
				}.bind(this),
			)
		}
		return tile
	},

	getTileUrl: function (coords: any) {
		// the key created from columns in the next format: {zoom_level}_{tile_column}_{tile_row}
		const tileData = storedTiles[`${coords.z}_${coords.x}_${this._globalTileRange.max.y - coords.y}`]

		// TODO: keep until the georeferenced map is ready
		// const row = this._stmt.getAsObject({
		// 	':x': coords.x,
		// 	':y': this._globalTileRange.max.y - coords.y,
		// 	':z': coords.z,
		// })

		if (tileData) {
			// if ('tile_data' in row) {
			return window.URL.createObjectURL(new Blob([tileData], { type: this._format }))
		} else {
			return L.Util.emptyImageUrl
		}
	},
})
;(L.tileLayer as any).mbTiles = function (databaseUrl: string | ArrayBuffer, options?: any) {
	return new (L.TileLayer as any).MBTiles(databaseUrl, options)
}

export const clearStoredTiles = () => {
	storedTiles = []
}
